import axios from "axios";
import axiosInstance from "../axiosInstance";

const BASE_URL = process.env.REACT_APP_API_URL;
const STAGE = process.env.REACT_APP_API_STAGE;

interface IParamsGetReport {
  stardate: string | Date;
  enddate: string | Date;
}

export const getReportAttendance = async (payload: IParamsGetReport) => {
  try {
    const response = await axiosInstance.get(
      `${BASE_URL}v1/${STAGE}/dashboard/attandence-reports/?startdate=${payload.stardate}&enddate=${payload.enddate}`
    );
    console.log("RES", response);

    return response.data;
  } catch (error) {
    console.log(error);
    console.log(axios.AxiosError);
  }
};

export const detailAttendanceApi = async (payload: any) => {
  try {
    const response = await axiosInstance.get(
      `${BASE_URL}v1/${STAGE}/dashboard/attandence/${payload}`
    );
    console.log("RES", response);

    return response.data;
  } catch (error) {
    console.log(error);
    console.log(axios.AxiosError);
  }
};

export const updateAttendanceApi = async (payload: any) => {
  try {
    console.log("LOL", payload);

    const response = await axiosInstance.put(
      `${BASE_URL}v1/${STAGE}/dashboard/attandence/${payload.id}`,
      payload
    );
    console.log("RES", response);

    return response.data;
  } catch (error) {
    console.log(error);
    console.log(axios.AxiosError);
  }
};

export const getAttendanceRequestApi = async (payload: any) => {
  try {
    const response = await axiosInstance.get(
      `${BASE_URL}v1/${STAGE}/dashboard/attendance-request/?startdate=${payload.startdate}&enddate=${payload.enddate}`
    );
    console.log("RES", response);

    return response.data;
  } catch (error) {
    console.log(error);
    console.log(axios.AxiosError);
  }
};

export const updateAttendanceRequestApi = async (payload: any) => {
  try {
    console.log("LOL", payload);

    const response = await axiosInstance.put(
      `${BASE_URL}v1/${STAGE}/dashboard/attendance-request-single/${payload.id}`,
      payload
    );
    console.log("RES", response);

    return response.data;
  } catch (error) {
    console.log(error);
    console.log(axios.AxiosError);
  }
};

export const updateAttendanceRequestAllApi = async () => {
  try {
    const response = await axiosInstance.put(
      `${BASE_URL}v1/${STAGE}/dashboard/attendance-request-all`
    );
    console.log("RES", response);

    return response.data;
  } catch (error) {
    console.log(error);
    console.log(axios.AxiosError);
  }
};
